import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { If } from 'src/Components'
import CreateHomeRedirect from './CreateHomeRedirect'
import CreateHomeError from './CreateHomeError'
import CreateHomeLoading from './CreateHomeLoading'
import {
  selectCreateAndLoadHomeComplete,
  selectCreateHomeError
} from 'src/store/selectors/home/homeCreate'

const propTypes = {
  restart: PropTypes.func
}

const CreateHome = ({ restart }) => {
  const createdAndLoaded = useSelector(selectCreateAndLoadHomeComplete)

  const error = useSelector(selectCreateHomeError)

  const [verified, setVerified] = useState(false)
  const [searched, setSearched] = useState(false)
  const [gathered, setGathered] = useState(false)
  const [crunched, setCrunched] = useState(false)
  const [complete, setComplete] = useState(false)

  useEffect(() => {
    const verifiedTimer = setTimeout(() => setVerified(true), 1000)
    const searchedTimer = setTimeout(() => setSearched(true), 2000)
    const gatheredTimer = setTimeout(() => setGathered(true), 3000)

    return () => {
      clearTimeout(verifiedTimer)
      clearTimeout(searchedTimer)
      clearTimeout(gatheredTimer)
    }
  }, [])

  useEffect(() => {
    if (createdAndLoaded && gathered) {
      setCrunched(true)
      setTimeout(() => setComplete(true), 1000)
    }
  }, [createdAndLoaded, gathered])

  return (
    <>
      <If condition={complete}>
        <CreateHomeRedirect />
      </If>

      <If condition={!error}>
        <CreateHomeLoading
          verified={verified}
          searched={searched}
          gathered={gathered}
          crunched={crunched}
        />
      </If>

      <If condition={error}>
        <CreateHomeError onClick={restart} />
      </If>
    </>
  )
}

CreateHome.propTypes = propTypes

export default CreateHome
